import { Button } from '@app/components/common/buttons/Button/Button';
import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { Card as AntCard, Typography as AntTypography } from 'antd';
import styled from 'styled-components';

export const Card = styled(AntCard)`
  max-width: 100%;
  width: 100%;
  margin: 52px auto 0;
  direction: rtl;
  background: transparent;
  padding: 0;
  border-radius: 12px;
  border: none;
  box-shadow: none;

  .ant-card-body {
    padding: 0;
    width: 100%;

    &:before,
    &:after {
      display: none;
    }
  }
`;

export const Content = styled.div`
  color: #1a295a;
  font-weight: ${FONT_WEIGHT.light};
  margin: 0;

  p,
  ul li {
    font-size: 22px;
    margin: 0;
  }

  @media screen and (max-width: 768px) {
    p,
    ul li {
      font-size: 18px;
    }
  }
`;

export const SaveButton = styled(Button)`
  margin-top: 10px;
`;

export const Typography = styled(AntTypography)`
  .client-title {
    color: #1a295a;
    font-size: 22px;
    font-weight: ${FONT_WEIGHT.extremeBold};
    margin-block-end: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .ant-typography:not(.client-title) {
    margin: 0;
    font-size: 22px;
    color: #1a295a;
    font-weight: ${FONT_WEIGHT.light};
  }

  @media screen and (max-width: 768px) {
    .client-title {
      font-size: 18px;
    }

    .ant-typography:not(.client-title) {
      font-size: 18px;
    }
  }
`;
